import React, { useState, useEffect, useRef, useContext } from 'react';
import styles from '../../css/components/content/media.css';
import PropTypes from 'prop-types';
import { getAssetUrl } from '../../helpers/get-asset-url';
import { useTranslation } from 'react-i18next';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

function MediaContent({
	imagesSrc,
	titles = [],
	onClose,
	isVideo,
	videoSrc = '',
	dataTestId = '',
	initialMediaIndex = 0,
	captionTexts = [],
	showPaginator = false,
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);

	const { t } = useTranslation('translation');

	const overlayRef = useRef();
	const containerRef = useRef();

	const onClickOutside = (e) => {
		if (!containerRef.current.contains(e.target)) {
			onClose();
		}
	};

	useEffect(() => {
		if(overlayRef){
			overlayRef.current.focus();
		}
	}, [overlayRef]);

	const handleKeyDown = (e) => {
		if(e.key === 'ArrowLeft'){
			previousSlide();
		}
		else if (e.key=== 'ArrowRight'){
			nextSlide();
		}
		else if(e.key === 'Escape') {
			onClose();
		}
	};

	const [mediaIndex, setMediaIndex] = useState(initialMediaIndex);

	function previousSlide(){
		if(mediaIndex === 0){
			setMediaIndex(imagesSrc.length - 1);
		}
		else{
			setMediaIndex(mediaIndex - 1);
		}
	}

	function nextSlide(){
		if(mediaIndex === imagesSrc.length - 1){
			setMediaIndex(0);
		}
		else {
			setMediaIndex(mediaIndex + 1);
		}
	}

	return(
		<div
			className={styles.mediaOverlay}
			data-testid={dataTestId}
			onClick={(e) => onClickOutside(e)}
		>
			<div
				className={styles.mediaOverlayContentWrapper}
				ref={containerRef}
			>
				<div
					className={`${styles.mediaContentBox} ${styles[onelpsParams.gameId]}`}
					ref={overlayRef}
					onKeyDown={handleKeyDown}
					tabIndex={-1}
				>
					<div className={`${styles.mediaContentLogo} ${styles[onelpsParams.gameId]}`}></div>
					<div className={`${styles.mediaContentBorder} ${styles[onelpsParams.gameId]}`}>
						{titles.length > 0 && titles[mediaIndex]}
						{!isVideo ? (
							<>
								<img
									className={styles.slide}
									src={getAssetUrl() + imagesSrc[mediaIndex]}
									onClick={() => nextSlide()}
									alt="currentScreeshot"
								/>
								{captionTexts.length > 0 && <span className={styles.caption}>{captionTexts[mediaIndex]}</span>}
								<button
									className={styles.contentButtonLeft}
									type='button'
									data-testid='content-left'
									onClick={() => previousSlide()}
								/>
								<button
									className={styles.contentButtonRight}
									type='button'
									data-testid='content-right'
									onClick={() => nextSlide()}
								/>
								{showPaginator && imagesSrc.length > 0 && (
									<div className={styles.paginator}>
										{t('belowTheFold.foe.mediaGallery.imagePaginator', { current: mediaIndex + 1, total: imagesSrc.length })}
									</div>
								)}
							</>
						) : (
							<>
								<iframe
									className={styles.slide}
									src={videoSrc}
									allowFullScreen='allowfullscreen'
								></iframe>
								<div className={`${styles.clear}`}></div>
							</>
						)}
						<button
							className={styles.contentButtonExit}
							type='button'
							data-testid='content-exit'
							onClick={() => onClose()}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default MediaContent;

MediaContent.propTypes = {
	imagesSrc: PropTypes.arrayOf(PropTypes.string).isRequired,
	titles: PropTypes.array,
	onClose: PropTypes.func.isRequired,
	isVideo: PropTypes.bool.isRequired,
	videoSrc: PropTypes.string,
	dataTestId: PropTypes.string,
	initialMediaIndex: PropTypes.number,
	captionTexts: PropTypes.arrayOf(PropTypes.string),
	showPaginator: PropTypes.bool,
};